export const chuyenHang = {
  sections: {
    list: { title: '调拨' },
    detail: { title: '调拨单详情' },
  },
  titles: { add: '新建调拨单' },
  columns: {
    code: '单号',
    summary: '摘要',
    status: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    branchFrom: '调出分支',
    branchTo: '调入分支',
    createdAt: '创建时间',
    transferValue: '调拨金额',
    transferDate: '调拨日期',
    receivedDate: '签收日期',
    totalQty: '总数量',
    totalReceivedQty: '已收数量',
    receivedValue: '已收金额',
    receiveNote: '签收备注',
    phieuKho: '仓库单据',
    maPhieuXuatKho: '出库单',
    maPhieuNhapKho: '入库单',
  },
  filter: {
    searchPlaceholder: '按单号搜索...',
    title: '筛选',
    trangThai: '状态',
    chiNhanhDi: '调出分支',
    chiNhanhDen: '调入分支',
    tuNgay: '起始日期',
    denNgay: '结束日期',
    fromDate: '起始日期',
    toDate: '结束日期',
    dateRangePlaceholder: '选择日期范围',
    all: '全部',
    reset: '重置',
    sortDir: '排序',
    asc: '升序',
    desc: '降序',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
  },
  placeholders: {
    toolbarSearch: '按单号',
  },
  filters: {
    hintSection: '提示',
    hintBody: '使用搜索快速筛选。',
  },
  form: {
    code: '单号',
    codeAuto: '留空自动生成',
    branchFrom: '调出分支',
    branchTo: '调入分支',
    note: '备注',
    lines: '调拨明细',
    addLine: '添加空行',
    product: '商品',
    productSearch: '搜索编码/名称',
    qty: '调拨数量',
    qtyReceived: '已收数量',
    unitPrice: '调拨价',
    donGiaMua: '调拨价',
    giaChuyen: '调拨价',
    donViTinhMua: '单位',
    dvt: '单位',
    maSp: '商品编码',
    tenSp: '商品名称',
    maHang: '商品编码',
    tenHang: '商品名称',
    stt: '序号',
    tonKho: '库存',
    tonKhoNhan: '调入库存',
    hinhThucVc: '运输方式',
    cont: '柜号',
    maVanChuyenNcc: '供应商运单号',
    maVanChuyenAzl: 'AZL运单号',
    maYcmh: '采购申请号',
    maBaoGia: '报价单号',
    giamGia: '折扣',
    serialImei: '序列号/IMEI',
    dateSanPham: '产品日期',
    lineAmount: '行金额',
    discount: '折扣',
    discountPercent: '折扣(%)',
    lineNote: '备注',
    createdAt: '创建时间',
    transferDate: '调拨日期',
    receivedDate: '签收日期',
    totalQty: '总数量',
    totalReceivedQty: '已收总数',
    receivedValue: '已收金额',
    receiveNote: '签收备注',
    sectionHeader: '基本信息',
    sectionLines: '调拨商品',
    tongSoMatHang: '品项数',
    tongSoLuong: '总数量',
    tongTienHang: '商品金额',
    lineCount: '{count} 行',
    save: '保存',
  },
  fields: {
    code: '单号',
    ngayChuyen: '调拨日期',
    ngayXuatKho: '出库时间',
    ngayNhapKho: '入库时间',
    transferValue: '调拨金额',
  },
  detailTabs: {
    chung: '总览',
    generalInfo: '信息',
    chiTietHang: '明细',
    flow: '调拨流程',
    lines: '调拨明细',
  },
  status: {
    phieuTam: '草稿',
    choXuat: '待出库',
    dangChuyen: '调拨中',
    daNhan: '已签收',
    daHuy: '已取消',
    cho: '待确认',
    daHoanThanh: '已完成',
  },
  messages: {
    importDescription:
      '选择收货分支，下载模板（编码/调拨数量/价格/折扣）。一个文件创建一张草稿。可直接导入或先预览再编辑。',
    importSuccess: '已从 Excel 导入商品。',
    importWillCreate: '将从 {count} 行商品创建 1 张调拨单。',
    importPreviewProgress: '预览调拨单',
    importPreviewLoading: '正在准备调拨单…',
    importPreviewDone: '已通过预览创建调拨单。',
    loadError: '无法加载列表。',
    deleteSuccess: '已删除调拨单。',
    huySuccess: '已取消调拨单。',
    confirmHuy: '取消调拨单 {name}？关联的出库单和入库单（如有）也将被取消：调出分店恢复库存，调入分店扣回已收数量。',
    createSuccess: '已创建调拨单。',
    updateSuccess: '已更新调拨单。',
    needLines: '请至少添加一行商品。',
    needChiNhanhDen: '保存前请选择调入分支。',
    needMaSp: '每一行都需填写商品编码。',
    needTenSp: '每一行都需填写商品名称。',
    needSoLuong: '每一行数量必须大于 0。',
    needDonViTinhMua: '每一行都需填写采购单位。',
    needMaLo: '请填写 {code} 的序列号/IMEI。',
    needHanSuDung: '请填写 {code} 的产品日期。',
    warnOverStock: '超出调出仓库存：{detail}',
    noData: '暂无调拨单。',
    noLines: '无明细行。',
    listSummary: '共 {count} 单',
    confirmDelete: '删除单 {name}？',
    completeSuccess: '调拨单已转为调拨中。',
    batDauChuyenSuccess: '已创建并完成出库单（扣减调出分店库存）。调拨单已转为调拨中。',
    hoanThanhXuatSuccess: '已完成出库（扣减调出库存）。调拨单转为调拨中。',
    receiveSuccess: '已创建入库单（增加调入库存）。调拨单已签收。',
    confirmComplete: '确定提交并转为调拨中？提交后不可修改。',
    confirmBatDauChuyen: '确认调拨 {code}？',
    confirmBatDauChuyenWarn: '此后不可再改商品明细',
    confirmBatDauChuyenHint1: '创建并完成出库单：立即扣减调出分店库存。',
    confirmBatDauChuyenHint2: '调拨单转为调拨中。',
    confirmBatDauChuyenHint3: '下一步：调入分店确认收货，创建入库单并增加库存。',
    confirmHoanThanhXuat: '完成调拨单 {code} 的出库？',
    confirmHoanThanhXuatWarn: '此操作将扣减调出分店库存',
    confirmHoanThanhXuatHint1: '完成出库单 {maPhieu}：扣减调出分店库存。',
    confirmHoanThanhXuatHint1NoCode: '完成出库单：扣减调出分店库存。',
    confirmHoanThanhXuatHint2: '调入分店确认收货时创建入库单。',
    confirmHoanThanhXuatHint3: '调拨单转为调拨中。',
    confirmReceive: '确认签收调拨单 {code}？',
    confirmReceiveWarn: '此操作将创建入库单并增加库存',
    confirmReceiveHint1: '完成入库单 {maPhieu}：增加调入分店库存。',
    confirmReceiveHint1NoCode: '创建并完成入库单：按实收数量增加调入分店库存，成本按出库成本。',
    confirmReceiveHint2: '调拨单转为已签收。此操作不可撤销。',
    needNgayXuatKho: '请选择出库时间。',
    needNgayChuyen: '请先选择调拨日期再保存。',
    ngayNhanMustAfterXuat: '入库时间必须晚于出库时间。',
  },
  actions: {
    complete: '完成调拨',
    batDauChuyen: '确认调拨',
    huyPhieu: '取消单据',
    hoanThanhXuat: '完成出库',
    confirmReceive: '确认收货',
    copy: '复制',
    addLine: '添加空行',
    importExcel: '导入 Excel',
    downloadTemplate: '下载模板',
    dongY: '确定',
  },
  aria: {
    columnPicker: '选择显示列',
    xuatKho: '调拨出库单',
    nhapKho: '调拨入库单',
    empty: '尚未创建',
    viewPhieuXuat: '查看出库单 {maPhieu}',
    viewPhieuNhap: '查看入库单 {maPhieu}',
    phieuCho: '待确认',
    phieuHoanThanh: '已完成',
    phieuHuy: '已取消',
  },
  theoDoi: {
    title: '调拨跟踪',
    tabs: {
      theoDoi: '跟踪',
      viecCuaToi: '我的任务',
      doiChieu: '对账',
    },
    steps: {
      tao: '草稿',
      choXuat: '待出库',
      xuat: '出库',
      dangChuyen: '调拨中',
      nhap: '入库',
      hoanThanh: '已签收',
      daNhan: '已签收',
    },
    searchPlaceholder: '按单号、分店搜索...',
    selectPrompt: '选择一张调拨单查看详情。',
    openDetail: '打开',
    totalQty: '总数量',
    receiveNotePlaceholder: '签收备注（可选）',
    noPending: '暂无待确认的调拨单。',
    xuatKho: '出库',
    nhapKho: '入库',
    col: {
      hangHoa: '商品',
      slChuyen: '调拨数量',
      slXuat: '出库数量',
      slNhan: '签收数量',
      chenhLech: '差异',
    },
  },
}
